var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Logger } from '@streamr/utils';
import { inject, Lifecycle, scoped } from 'tsyringe';
import { ConfigInjectionToken } from '../ConfigTypes';
let LoggerFactory = class LoggerFactory {
    config;
    constructor(config) {
        this.config = config;
    }
    createLogger(loggerModule) {
        return new Logger(loggerModule, { id: this.config.id }, this.config.logLevel);
    }
};
LoggerFactory = __decorate([
    scoped(Lifecycle.ContainerScoped),
    __param(0, inject(ConfigInjectionToken)),
    __metadata("design:paramtypes", [Object])
], LoggerFactory);
export { LoggerFactory };
//# sourceMappingURL=LoggerFactory.js.map